// extracted by mini-css-extract-plugin
module.exports = {"setPasswordButton":"PasswordInputs_setPasswordButton__2CXWT","redirectMessage":"PasswordInputs_redirectMessage__1F5rF","errorCard":"PasswordInputs_errorCard__v7Wax"};